import React, { useEffect, useState } from "react";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import InfiniteScroll from "react-infinite-scroll-component";
import Button from "components/CustomButton";
import AllTodoList from "components/AllTodoList";
import Scrollbar from "react-scrollbars-custom";

const style = {
  loaderStyle: {
    display: "flex",
    justifyContent: "center",
  },
  moreButton: {
    display: "flex",
    justifyContent: "center",
  },
  buttonStyle: {
    background:
      "transparent linear-gradient(103deg, #ffa100 0%, #ffc42f 52%, #ffe75e 100%) 0% 0% no-repeat padding-box",
  },
};
export default ({ teamIds, selectedTeamId }) => {
  const classes = style;
  const [allList, setAllList] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setLoading] = useState(true);
  const [total, setTotal] = useState("");

  useEffect(() => {
    if (!selectedTeamId) {
      return;
    }

    if (selectedTeamId !== teamIds) {
      return;
    }

    (async () => {
      try {
        setLoading(true);
        var response = await TeamService.getTodoList(selectedTeamId, page);

        setAllList(Array.from(new Set([...response?.data?.data, ...allList])));
        setTotal(response?.data?.meta?.total);
        setLoading(false);
      } catch (e) {
        console.error(e);
      }
    })();

    return () => {
      setAllList([]);
    };

    //eslint-disable-next-line
  }, [selectedTeamId, page]);

  const getNextPageData = () => {
    setPage(page + 1);
  };

  const LoadingContainer = (
    <>
      {isLoading && (
        <h4>
          <Loader loaderStyle={classes.loaderStyle} width={50} height={50} />
        </h4>
      )}
      {!isLoading && (
        <h4 style={classes.moreButton}>
          <Button
            onClick={getNextPageData}
            buttonStyle={classes.buttonStyle}
            buttonClass="small-btn"
          >
            Load More
          </Button>
        </h4>
      )}
    </>
  );

  return (
    <div className="allListShareContent">
      <Scrollbar
        translateContentSizeYToHolder={true}
        style={{
          maxHeight: "140px",
        }}
      >
        <div className="listShareContent">
          <span>
            <InfiniteScroll
              style={{ overflow: "hidden" }}
              dataLength={total ?? 0}
              next={getNextPageData}
              hasMore={allList.length !== total}
              loader={LoadingContainer}
              scrollableTarget="main-panel-right"
              endMessage={
                <div style={{ textAlign: "center", paddingTop: "10px" }}>
                  {total > 0 && <div>Yay! You have seen it all</div>}
                </div>
              }
            >
              <AllTodoList allList={allList} total={total} />
            </InfiniteScroll>
          </span>
        </div>
      </Scrollbar>
    </div>
  );
};
